import { JSEncrypt } from 'jsencrypt';
const md5Util = require('./md5');
// 实例化rsa
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCctQTweXAiaQ3ct5bhj6nyisOQiGmgC/hUdK+QO9I9DudcQSUMxIXvMtpiogB9RWkAUC4b86x7SiGD6aCp7PbTspd5fLf8F6LUIj/BtmktQq7JNsShjAWBxCkE49HIIvPvl9rt8lO7MkgS2vUT04tEYeu/62ltOc3BljJXoPC4pQIDAQAB';

function rasEncry(str) {
    const encryptor = new JSEncrypt(); // 创建加密对象实例
    // 之前ssl生成的公钥，复制的时候要小心不要有空格
    encryptor.setPublicKey(publicKey); // 设置公钥
    return encryptor.encrypt(str);
}

//  md5加密
const encrySalt = 'OoZi3kZ3B0MF91Kx';

function dataMd5(str) {
    return md5Util.hex_md5(str);
}

function dataMd5Encry(str) {
    return md5Util.hex_md5(md5Util.hex_md5(md5Util.hex_md5(str) + encrySalt));
}

export default {
    rasEncry: rasEncry,
    dataMd5Encry: dataMd5Encry,
    dataMd5: dataMd5
}